/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mail_SubjectInputs */



/**
* | output |
* | --- |
* | "Request error ({app})" |
*
* @param {Mail_SubjectInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mail_subject = /** @type {((inputs: Mail_SubjectInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_SubjectInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Request error (${i?.app})`)
	return /** @type {LocalizedString} */ (`Erreur requête ${i?.app}`)
});